// extracted by css-extract-rspack-plugin
export default {"container":"CommentLayout-module__container__VJmbA","header":"CommentLayout-module__header__aBhEn","body":"CommentLayout-module__body__Dx8qi"};